import { createColumnHelper } from '@tanstack/react-table';
import cn from 'classnames';
import { useMemo } from 'react';
import { Timestamp } from '#components/atoms/timestamp/Timestamp.tsx';
import { Table } from '#components/patterns/table/Table.tsx';
import type { TOTPAuthenticatorListItem } from '#dn-types/totp-authenticators.ts';
import { LastSeenAt } from '../../last-seen-at/LastSeenAt.tsx';
import { TOTPActionMenu } from '../action-menu/TOTPActionMenu.tsx';

type Props = {
  data: TOTPAuthenticatorListItem[];
  isFetching: boolean;
};

const columnHelper = createColumnHelper<TOTPAuthenticatorListItem>();

export function TOTPList({ data, isFetching }: Props) {
  const columns = useMemo(
    () => [
      columnHelper.accessor('name', {
        header: 'Name',
        size: 360,
        meta: {
          truncate: true,
        },
        cell(info) {
          const name = info.getValue();
          return name || <span className="i">unnamed</span>;
        },
      }),
      columnHelper.accessor('createdAt', {
        header: 'Created',
        size: 80,
        cell(info) {
          return <Timestamp datetime={info.getValue()} format="M/d/yyyy" />;
        },
        meta: {
          truncate: true,
        },
      }),
      columnHelper.accessor('lastSeenAt', {
        header: 'Last used',
        size: 80,
        cell(info) {
          const { lastSeenAt } = info.row.original;
          return <LastSeenAt lastSeenAt={lastSeenAt} />;
        },
      }),
      columnHelper.display({
        id: 'action-menu',
        header: '',
        size: 34,
        cell(info) {
          const { id } = info.row.original;
          return (
            <div className="flex justify-end">
              <TOTPActionMenu value={id} />
            </div>
          );
        },
      }),
    ],
    []
  );

  return (
    <div className={cn({ 'opacity-dim': isFetching })}>
      <Table data={data} columns={columns} caption="Authenticator apps" className="mb-24 border-b" />
    </div>
  );
}
